import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { SAP_MERCHANT_TYPE } from '../enums';

@Pipe({
  name: 'sapMerchantType'
})
export class SapMerchantTypePipe extends EnumConverter implements PipeTransform {
  enumeration = SAP_MERCHANT_TYPE;
}
